import src from "IMAGE";
export default { src, width: 300, height: 269, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
